import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-165" data-mp="hvgl64lgx6wp">
      <div className="mx-auto max-w-6xl" data-id="element-166" data-mp="3zv20e1x1hc7">
        <SectionHeading id="volumes-heading" title={<>
              Your Complete Lash &amp; Brow <Accent data-id="element-168" data-mp="vq98hp7lnrdu">Teaching Library</Accent>
            </>} data-id="element-167" data-mp="7yu47qw9izzy" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-169" data-mp="10oascccunuqd">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[22px] bg-white shadow-[0_24px_50px_-36px_rgba(24,45,42,0.45)] ring-1 ring-brand-gold/25" data-id="element-170" data-mp="mvus1jbc2at5">
              <div className="relative flex min-h-[170px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-171" data-mp="1elplns684mnm">
                <span aria-hidden="true" className="pointer-events-none absolute right-5 top-2 font-script text-[3.5rem] leading-none text-white/80" data-id="element-172" data-mp="ckzxko67sjd3">
                  {volume.number}
                </span>
                <span className="relative self-start rounded-full bg-white/80 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-173" data-mp="mcdt6kv1oz0y">
                  Volume {volume.number}
                </span>
                <h3 className="relative mt-auto pt-5 font-display text-[1.4rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-174" data-mp="raflzxi9wcpm">
                  {volume.title}
                </h3>
              </div>
              <div className="flex flex-1 flex-col px-6 py-5" data-id="element-175" data-mp="10b3phya1iuo9">
                <span aria-hidden="true" className="block h-px w-10 bg-brand-gold/60" data-id="element-176" data-mp="10bn538c7x6z4" />
                <p className="mt-3 text-[14px] leading-relaxed text-brand-charcoal/70" data-id="element-177" data-mp="371tnvqxdx7vv">{volume.description}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-178" data-mp="15zu3whmi9ooj">
          Certificate resources in Volume 6 are for internal course completion only. They are not official
          professional accreditation or licensing.
        </p>
      </div>
    </section>;
}